import React, { useState } from "react";
import { filesData } from "../../data/files";
import Tabs from "./components/Tabs";
import FileGrid from "./components/FileGrid";

const FilesManager = () => {
  const [activeTab, setActiveTab] = useState("all");

  return (
    <div
    style={{
      display: "flex",
      backgroundColor: "#F5F7FA", 
      height: "100vh", 
      flexDirection: "column"
    }}
  >
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <FileGrid files={filesData[activeTab]} />
    </div>
  );
};

export default FilesManager;
